import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { DynamicDialog } from 'components/shared';
import UserFormSteps from 'components/user/user_form_steps';
import { useEffect } from 'react';
import useModel from './model.form';
import {
  getAllStatus,
  getByIdInstitution,
  updateByIdInstitution,
} from 'api/institutions/institution.api';
import { useNavigate, useParams } from 'react-router-dom';
import { getGroupsDropdown } from 'api/group/group.api';
import { getInstitutionProfilesDropdown } from 'api/profile/profile.api';
import { ROUTES } from 'routes/constants';
import IconErrorNetwork from '../../../assets/icons/error_network.svg';
import IconUpdated from '../../../assets/icons/updated-icon.svg';
import {
  MSG_DATA_ERROR,
  MSG_INSTITUTION_ID_NOT_FOUND,
  MSG_FINISH,
  MSG_INSTITUTION_UPDATED,
  MSG_INSTITUTION_WAS_UPDATED,
} from 'common/messages';
import { ErrorDto } from 'common/dtos/error.dto';
import { maxStep, minStep } from './types.form';
import InstitutionFormStepOne from './institution.form.step-one';
import CustomButton from 'components/shared/custom_button';
import InstitutionFormStepTwo from './institution.form.step-two';
import ContainerPainel from 'components/container_painel';
import { InstitutionStatusEnum } from 'common/enums';
import ErrorAlertModal from 'components/shared/error_alert_modal';
import { ModuleEnum, PermissionType, usePermissions } from 'contexts/auth/permission_context';

const InstitutionForm: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!hasPermission(ModuleEnum.INSTITUTIONS, PermissionType.UPDATE)) {
      navigate(ROUTES.HOME);
    }
  }, []);





  const {
    state,
    screenError,
    setInstitution,
    setGroupList,
    setProfileList,
    setStatusList,
    setToAddStatusList,
    setToDelStatusList,
    setError,
    setIncreaseStep,
    setDecreaseStep,
    setHasError,
    setHasFinishInstitutionUpdate,
    setStateOnFormikChange,
    setScreenError,
  } = useModel();

  useEffect(() => {
    if (state.statusList.length > 0 && state.institution) {
      const activeInstitutions = state.institution.statusList.some(
        (item: any) => item.name === InstitutionStatusEnum.REGISTER_ACTIVE,
      );
      if (activeInstitutions) {
        setToAddStatusList(InstitutionStatusEnum.REGISTER_ACTIVE, true);
      }
    }
  }, [state.institution, state.statusList]);

  const fetchGetData = async () => {
    setError(null);

    if (!uuid) {
      setError({
        title: MSG_DATA_ERROR,
        message: MSG_INSTITUTION_ID_NOT_FOUND,
      });
      return;
    }





    try {
      const [institution, groupList, statusList] = await Promise.all([
        getByIdInstitution(uuid),
        getGroupsDropdown(),
        getAllStatus(),
      ]);
      institution.statusList = institution.institutionStatusList.map(
        (item: any) => item?.status,
      );

      setInstitution(institution);
      setGroupList(groupList.data);
      setStatusList(statusList.data);
    } catch (error) {
      const err = error as ErrorDto;
      setError(err);
    }
  };





  const fetchGetAllProfile = async () => {
    setError(null);

    try {
      const profileList = await getInstitutionProfilesDropdown(
        state.institution?.profile?.group?.uuid,
      );

      setProfileList(profileList.data);
    } catch (error) {
      const err = error as ErrorDto;
      setError(err);
    }
  };






  const fetchUpdate = async () => {
    setError(null);

    if (!uuid) {
      setError({
        title: MSG_DATA_ERROR,
        message: MSG_INSTITUTION_ID_NOT_FOUND,
      });
      return;
    }

    try {
      console.log(state);
      await updateByIdInstitution(uuid, state);
      setHasFinishInstitutionUpdate(true);
    } catch (error) {
      const err = error as ErrorDto;
      console.error('err:', err);
      setError(err);
    }
  };

  useEffect(() => {
    fetchGetData();
  }, []);

  useEffect(() => {
    fetchGetData();
  }, [uuid]);

  useEffect(() => {
    fetchGetAllProfile();
  }, [state.institution?.profile?.group?.uuid]);







  return (
    <ContainerPainel pagina='Editar Instituições' showBackButton={true}>
      {screenError && (
        <ErrorAlertModal
          open={screenError.length > 0}
          title='Telefone não informado'
          message={screenError}
          onClose={() => setScreenError('')}
        />
      )}

      <Box
        sx={{
          backgroundColor: '#FAFAFA',
        }}
      >
        <UserFormSteps activeStep={state.step} />





        <Box
          sx={{
            height: '79px',
            gap: '24px',
          }}
        >
          <Typography variant='h5'>
            {state.step === 1 ? 'Dados principais' : 'Confirmação dos dados'}
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '22.88px',
              letterSpacing: '0.17px',
              textAlign: 'center',
              marginTop: '20px',
            }}
          >
            {state.step === 1
              ? 'Informe corretamente os dados principais da instituição cadastrada.'
              : 'Confira todas as informações que foram preenchidas, e altere-as caso necessário.'}
          </Typography>
        </Box>
      </Box>

      {state.step === 1 && (
        <InstitutionFormStepOne
          state={state}
          setToAddStatusList={setToAddStatusList}
          setToDelStatusList={setToDelStatusList}
          setHasError={setHasError}
          setStateOnFormikChange={setStateOnFormikChange}
        />
      )}





      {state.step === 2 && <InstitutionFormStepTwo state={state} />}

      <Box sx={{ mt: '16px', display: 'flex', justifyContent: 'center' }}>
        {state.step !== minStep && (
          <Box paddingX='16px'>
            <CustomButton name='back' onAction={setDecreaseStep} />
          </Box>
        )}

        {state.step !== maxStep && (
          <Box paddingX='16px'>
            <Button
              variant='text'
              onClick={() => navigate(ROUTES.INSTITUTION)}
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '24px',
                letterSpacing: '0.4px',
                textAlign: 'left',
                color: '#0048B6',
                marginRight: '20px',
              }}
            >
              VOLTAR
            </Button>
            <CustomButton name='next' onAction={setIncreaseStep} />
          </Box>
        )}

        {state.step === maxStep && (
          <Box paddingX='16px'>
            <CustomButton name='submit' onAction={() => fetchUpdate()} />
          </Box>
        )}
      </Box>






      <DynamicDialog
        isOpen={!!state.error || state.hasFinishInstitutionUpdate}
        icon={(() => {
          if (state.error) return IconErrorNetwork;
          else if (state.hasFinishInstitutionUpdate) return IconUpdated;
          return '//TODO: Icone generico.';
        })()}
        title={(() => {
          if (state.error) return state.error?.title ?? state.error?.code;
          else if (state.hasFinishInstitutionUpdate)
            return MSG_INSTITUTION_UPDATED;
          return '//TODO: Titulo generico.';
        })()}
        message={(() => {
          if (state.error) return state.error?.message;
          else if (state.hasFinishInstitutionUpdate)
            return MSG_INSTITUTION_WAS_UPDATED;
          return '//TODO: Mensagem generica.';
        })()}
        buttonText={MSG_FINISH.toUpperCase()}
        onClose={() => setError(null)}
        routeOnClose={(() => {
          if (state.hasFinishInstitutionUpdate) return ROUTES.INSTITUTION;
        })()}
      />
    </ContainerPainel>
  );
};

export default InstitutionForm;

// Helpers exported for testing
export const getDialogIcon = (state: any) => {
  if (state.error) return IconErrorNetwork;
  if (state.hasFinishInstitutionUpdate) return IconUpdated;
  return '//TODO: Icone generico.';
};

export const getDialogTitle = (state: any) => {
  if (state.error) return state.error?.title ?? state.error?.code;
  if (state.hasFinishInstitutionUpdate) return MSG_INSTITUTION_UPDATED;
  return '//TODO: Titulo generico.';
};

export const getDialogMessage = (state: any) => {
  if (state.error) return state.error?.message;
  if (state.hasFinishInstitutionUpdate) return MSG_INSTITUTION_WAS_UPDATED;
  return '//TODO: Mensagem generica.';
};

export const getHeaderTitle = (step: number) => (step === 1 ? 'Dados principais' : 'Confirmação dos dados');

export const getHeaderSubtitle = (step: number) =>
  step === 1
    ? 'Informe corretamente os dados principais da instituição cadastrada.'
    : 'Confira todas as informações que foram preenchidas, e altere-as caso necessário.';
